import { render, staticRenderFns } from "./FBAExclDown.vue?vue&type=template&id=adf49ee8&scoped=true&"
import script from "./FBAExclDown.vue?vue&type=script&lang=js&"
export * from "./FBAExclDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf49ee8",
  null
  
)

export default component.exports